import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

interface IRoute {
  exact?: boolean;
  path: string;
  component: FC;
}

interface SwitchRouter {
  routes?: IRoute[];
}

const renderRoute = ({ exact: _exact, ...route }: IRoute, index: number): JSX.Element => {
  const Component = route.component;

  return <Route key={index} path={route.path} element={<Component />} />;
};

const SwitchRouter = ({ routes }: SwitchRouter): JSX.Element => {
  return (
    <Routes>
      {routes?.length > 0 && routes.map(renderRoute)}
    </Routes>
  );
};

export default SwitchRouter;
